export const environment = {
  production: false,
  dataVersion: 5,
  version: '2.1.4',
  name: 'dev',
  electron: false,
  defaultEditor: true,
  showSourceBtn: true,
  firebase: {
    apiKey: 'AIzaSyDMmqISyiiWwgugYZ7XdJCSQL65W0unfbk',
    authDomain: 'vsight-remote-angular-dev.firebaseapp.com',
    databaseURL:
      'https://vsight-remote-angular-dev-4d310.europe-west1.firebasedatabase.app/',
    projectId: 'vsight-remote-angular-dev',
    storageBucket: 'hangaarlab-remote',
    messagingSenderId: '848344207337',
  },
  endPoints: {
    remoteBase: 'https://dev.vsight.io',
    adminBase: 'https://admin-dev.vsight.io',
    workflowBase: 'https://workflow-dev.vsight.io',
    novaBase: 'https://vsight.github.io',
    novaUrl: 'https://vsight.github.io/vsight-nova-ai-chat',
    login: 'https://workflow-dev.vsight.io/api/login',
    joinwithlink: 'https://workflow-dev.vsight.io/api/joinwithlink',
    createuser: 'https://workflow-dev.vsight.io/api/createuser',
    updateuser: 'https://workflow-dev.vsight.io/api/updateuser',
    deleteuser: 'https://workflow-dev.vsight.io/api/deleteuser',
    changepsd: 'https://workflow-dev.vsight.io/api/changepsd',
    senduserinvite: 'https://workflow-dev.vsight.io/api/senduserinvite',
    senduserpasswordreset: 'https://workflow-dev.vsight.io/api/senduserpasswordreset',
    getuserpasswordlinkdata: 'https://workflow-dev.vsight.io/api/getuserpasswordlinkdata',
    setuserpasswordwithlink: 'https://workflow-dev.vsight.io/api/setuserpasswordwithlink',
    generateremoveqr: 'https://workflow-dev.vsight.io/api/generateremoveqr',
    getAllWorkflows: 'https://workflow-dev.vsight.io/api/getAllWorkflows',
    getAllWorkflowReports:
      'https://workflow-dev.vsight.io/api/getAllWorkflowReports',
    getAllUsersForWorkflow:
      'https://workflow-dev.vsight.io/api/getAllUsersForWorkflow',
    createWorkflow: 'https://workflow-dev.vsight.io/api/createWorkflow',
    createWorkflowDraft:
      'https://workflow-dev.vsight.io/api/createWorkflowDraft',
    publishWorkflowDraft:
      'https://workflow-dev.vsight.io/api/publishWorkflowDraft',
    makeVideoFlowWorkflow:
      'https://workflow-dev.vsight.io/api/makeVideoFlowWorkflow',
    getPublishedWorkflowVersion:
      'https://workflow-dev.vsight.io/api/getPublishedWorkflowVersion',
    getWorkflowReport: 'https://workflow-dev.vsight.io/api/getWorkflowReport',
    setWorkflowDraft: 'https://workflow-dev.vsight.io/api/setWorkflowDraft',
    updateWorkflowUsers:
      'https://workflow-dev.vsight.io/api/updateWorkflowUsers',
    updateWorkflow: 'https://us-central1-vsight-remote-angular-dev.cloudfunctions.net/updateWorkflow',
    deleteWorkflow: 'https://workflow-dev.vsight.io/api/deleteWorkflow',
    getWorkflowAccountLabels:
      'https://workflow-dev.vsight.io/api/getWorkflowAccountLabels',
    setWorkflowAccountLabels:
      'https://workflow-dev.vsight.io/api/setWorkflowAccountLabels',
    updateWorkflowAccountUsers:
      'https://workflow-dev.vsight.io/api/updateWorkflowAccountUsers',
    createWorkflowReport:
      'https://workflow-dev.vsight.io/api/createWorkflowReport',
    getWorkflowList: 'https://workflow-dev.vsight.io/api/getworkflowlist',
    getAllPublishedWorkflowVersions:
      'https://workflow-dev.vsight.io/api/getAllPublishedWorkflowVersions',
    updateWorkflowReport:
      'https://workflow-dev.vsight.io/api/updateWorkflowReport',
    getUserWorkflowReports:
      'https://workflow-dev.vsight.io/api/getUserWorkflowReports',
    deleteWorkflowReport:
      'https://workflow-dev.vsight.io/api/deleteWorkflowReport',
    getWorkflowAccountExtraDetails:
      'https://workflow-dev.vsight.io/api/getWorkflowAccountExtraDetails',
    workflowQrGenerate: 'https://workflow-dev.vsight.io/api/workflowQrGenerate',
    workflowQrGetData: 'https://workflow-dev.vsight.io/api/workflowQrGetData',
    workflowQrGetCredentials:
      'https://workflow-dev.vsight.io/api/workflowQrGetCredentials',
    getWorkflow: 'https://workflow-dev.vsight.io/api/getworkflow',
    workflowQrDelete: 'https://workflow-dev.vsight.io/api/workflowQrDelete',
    translate: 'https://workflow-dev.vsight.io/api/translate',
    workflowGenerate: 'https://workflow-dev.vsight.io/api/workflowGenerate',
    switchToWorkflow: 'https://workflow-dev.vsight.io/api/switchToWorkflow',
    switchToRemote: 'https://workflow-dev.vsight.io/api/switchToRemote',
    saveApprover: 'https://workflow-dev.vsight.io/api/saveApprover',
    sendWorkflowReportToSign:
      'https://workflow-dev.vsight.io/api/sendWorkflowReportToSign',
    getWorkflowReportLinkData:
      'https://workflow-dev.vsight.io/api/getWorkflowReportLinkData',
    signWorkflowReport: 'https://workflow-dev.vsight.io/api/signWorkflowReport',
    sendWorkflowReportAfterApproval:
      'https://workflow-dev.vsight.io/api/sendWorkflowReportAfterApproval',
    getAccountData: 'https://workflow-dev.vsight.io/api/getAccountData',
    getId: 'https://workflow-dev.vsight.io/api/getId',
    workflowRemoteIntegrationGetId:
      'https://workflow-dev.vsight.io/api/workflowRemoteIntegrationGetId',
    workflowRemoteIntegrationUsers:
      'https://workflow-dev.vsight.io/api/workflowRemoteIntegrationUsers',
    workflowRemoteIntegrationInfo:
      'https://workflow-dev.vsight.io/api/workflowRemoteIntegrationInfo',
    workflowReportToPrefilled:
      'https://workflow-dev.vsight.io/api/workflowReportToPrefilled',
    setWorkflowAccountFolders:
      'https://workflow-dev.vsight.io/api/setWorkflowAccountFolders',
    changeWebhook: 'https://workflow-dev.vsight.io/api/changeWebhook',
    getWorkflowWithDraft:
      'https://workflow-dev.vsight.io/api/getWorkflowWithDraft',
    createWorkOrder: 'https://workflow-dev.vsight.io/api/createWorkorder',
    deleteWorkOrder: 'https://workflow-dev.vsight.io/api/deleteWorkorder',
    getWorkOrder: 'https://workflow-dev.vsight.io/api/getWorkorder',
    getWorkOrders: 'https://workflow-dev.vsight.io/api/getWorkorders',
    updateWorkOrder: 'https://workflow-dev.vsight.io/api/updateWorkorder',
    getAllWorkflowsMeta:
      'https://workflow-dev.vsight.io/api/getAllWorkflowsMeta',
    setWorkorderLabels: 'https://workflow-dev.vsight.io/api/setWorkorderLabels',
    getWorkorderLabels: 'https://workflow-dev.vsight.io/api/getWorkorderLabels',
    sendWorkorderComment:
      'https://workflow-dev.vsight.io/api/sendWorkorderComment',
    updateWorkorderForClient:
      'https://workflow-dev.vsight.io/api/updateWorkorderForClient',
    getMyWorkorders: 'https://workflow-dev.vsight.io/api/getMyWorkorders',
    getAllUsersForWorkorder:
      'https://workflow-dev.vsight.io/api/getAllUsersForWorkorder',
    updateroom: 'https://workflow-dev.vsight.io/api/updateroom',
    createroom: 'https://workflow-dev.vsight.io/api/createroom',
    deleteroom: 'https://workflow-dev.vsight.io/api/deleteroom',
    toggleroom: 'https://workflow-dev.vsight.io/api/toggleroom',
    exportsession: 'https://workflow-dev.vsight.io/api/exportsession',
    schedulemeeting: 'https://workflow-dev.vsight.io/api/schedulemeeting',
    cancelmeeting: 'https://workflow-dev.vsight.io/api/cancelmeeting',
    callusers: 'https://workflow-dev.vsight.io/api/callusers',
    getExportPDF: 'https://workflow-dev.vsight.io/api/generateSessionExportPdf',
    wipeSessionData: 'https://workflow-dev.vsight.io/api/wipeSessionData',
    changearchive: 'https://workflow-dev.vsight.io/api/changearchive',
    getUserContacts: 'https://workflow-dev.vsight.io/api/getUserContacts',
    getUserSessions: 'https://workflow-dev.vsight.io/apiV2/getUserSessions',
    getUserTickets: 'https://workflow-dev.vsight.io/apiV2/getUserTickets',
    getTicketDetails: 'https://workflow-dev.vsight.io/apiV2/getTicketDetails',
    createticket: 'https://workflow-dev.vsight.io/api/createticket',
    attachticket: 'https://workflow-dev.vsight.io/api/attachticket',
    detachticket: 'https://workflow-dev.vsight.io/api/detachticket',
    updateticket: 'https://workflow-dev.vsight.io/api/updateticket',
    deleteticket: 'https://workflow-dev.vsight.io/api/deleteticket',
    deleteTicketFile: 'https://workflow-dev.vsight.io/api/deleteTicketFile',
    getTicketTypes: 'https://workflow-dev.vsight.io/apiV2/getTicketTypes',
    addTicketChat: 'https://workflow-dev.vsight.io/api/addTicketChat',
    saveTicketTypes: 'https://workflow-dev.vsight.io/apiV2/saveTicketTypes',
    changeazure: 'https://workflow-dev.vsight.io/api/changeazure',
    changesettings: 'https://workflow-dev.vsight.io/api/changesettings',
    setserviceemail: 'https://workflow-dev.vsight.io/api/setserviceemail',
    passwordstrength: 'https://workflow-dev.vsight.io/api/passwordstrength',
    twofactorauth: 'https://workflow-dev.vsight.io/api/twofactorauth',
    admin_sso: 'https://workflow-dev.vsight.io/api/admin_sso',
    workflowVectorSearch:
      'https://workflow-dev.vsight.io/api/workflowVectorSearch',
    assignSharedWorkflowUsers:
      'https://us-central1-vsight-remote-angular-dev.cloudfunctions.net/assignSharedWorkflowUsers',
    getSharedWorkflowAssignments:
      'https://us-central1-vsight-remote-angular-dev.cloudfunctions.net/getSharedWorkflowAssignments',
    getOrganizationStats:
      'https://us-central1-vsight-remote-angular-dev.cloudfunctions.net/getOrganizationStats',
  },
  cnEndPoints: {
    socketserver: 'https://cn.vsight.io',
    getidtoken: 'https://cn.vsight.io/api/getidtoken',
  },
  design: {
    appName: 'VSight',
    shortName: 'VSight',
    addWorkflowToName: true,
    showSettings: true,
    webviewEnvironment: false,
    showLabels: true,
    supportedEvents: ['WorkflowReportSubmitted'],
    showVSightRemoteWidget: true,
    showFormWidget: true,
    continueWithQr: true,
    guestLoginLinkAvailable: false,
    remoteCallAvailable: true,
    idWidgetTranslation: false,
    wideLogo: false,
    logo: 'assets/img/logo.png',
    legalLogo: 'assets/img/logo.svg',
    sidebarLogo: 'assets/img/vsight-logo.svg',
    navbarLogo: 'assets/img/vsight-navbar-logo.svg',
    logoWhiteBg: false,
    logoStyle: {},
    leftLogoBgStyle: { 'background-color': '#e2edf7' },
    rightLogoBgStyle: { 'background': 'transparent linear-gradient(45deg, #003DA6 0%, #66D8E5 100%) 0% 0%' },
    wideLegalLogo: false,
    squareLogo: 'assets/img/square_logo.png',
    showMsLogin: true,
    msLoginSquareLogo: false,
    msLoginText: 'Sign in with Microsoft',
    msLoginTextDE: 'Mit Microsoft anmelden',
    showAdamosLogin: true,
    adamosLoginText: 'Sign in with ADAMOS',
    adamosLoginTextDE: 'Mit ADAMOS anmelden',
    addRemoteToName: false,
    useBaseUrlInsteadOfWindowOrigin: true,
    loginColor: '#00142E',
    linkColor: '#14389B',
    sidebarColor: '#003DA6',
    primaryColor: '#002E7D',
    primaryColorLight: '#2059BF',
    contactMail: 'info@vsight.io',
    termsCountryAndDistrict: {
      country: 'Germany',
      district: 'Frankfurt',
    },
    showPoweredBy: false,
    showArchivePermission: true,
    showAzureAdIntegration: true,
    showSsoLogin: true,
    showWorkflowEditorLink: true,
    legalAppName: 'Vsight',
    legalName: 'app.vsight.io',
    legalMail: 'legal@vsight.io',
    appStoreLink: 'https://apps.apple.com/us/app/vsight-workflow/id1606358495',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.remote.app.workflow&referrer=utm-source%3Dvsight%26utm_medium%3Dguest%26utm_content%3Dwid-',
    remoteAppStoreLink:
      'https://apps.apple.com/us/app/vsight-remote-ar-help/id1460130334',
    remoteGooglePlayLink:
      'https://play.google.com/store/apps/details?id=com.hangaarlab.vsight.remoteapp',
    remoteApkLink: 'https://dev.vsight.io/downloads/remote/apk',
  },
  azureAdConfig: {
    samlEntityId: 'https://dev.vsight.io/${name}/saml',
    samlReplyUrl: 'https://dev.vsight.io/${name}/saml/login',
    samlReplyUrl2: 'https://admin-dev.vsight.io/${name}/saml/login',
    samlReplyUrl3: 'https://dev.ar-remote-assistance.com/${name}/saml/login',
    scimEndpoint: 'https://dev.vsight.io/${name}/scim',
    msLoginUrl:
      'https://dev.ar-remote-assistance.com/${name}/saml/login?RelayState=unified',
  },
  // Generic OIDC (SSO) login config, same shape as azureAdConfig.msLoginUrl
  oidcConfig: {
    oidcLoginUrl: 'https://dev.ar-remote-assistance.com/oauth/${name}/login',
  },
  oauthOIDCConfig: {
    initiateLoginUrl:
      'https://dev.ar-remote-assistance.com/oauth/${name}/login',
    redirectUrl: 'https://dev.ar-remote-assistance.com/oauth/${name}/callback',
  },
};